import { render } from "./TestUserSelector.vue?vue&type=template&id=3463a09a&scoped=true"
import script from "./TestUserSelector.vue?vue&type=script&lang=js"
export * from "./TestUserSelector.vue?vue&type=script&lang=js"

import "./TestUserSelector.vue?vue&type=style&index=0&id=3463a09a&lang=scss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3463a09a"]])

export default __exports__